import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledTrainingActivity = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow-y: auto;

  .questions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 20px;

    .listened {
      border-color: ${Colors.success};
      background-color: ${Colors.success}11;

      .question-card-text {
        color: ${Colors.success};
      }
    }
  }

  .finish-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .title {
      font-size: 24px;
      font-weight: bold;
      color: ${Colors.success};
    }

    .subtitle {
      font-size: 18px;
      color: ${Colors.text};
      text-align: center;
      margin-top: 20px;
    }
  }
`;
